import { normalize } from '@dtvgo/typed-normalizr';
import { ChannelEntity } from '../../utils/normalizr/entities.js';
import '../../utils/normalizr/interfaces.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';
import '@dtvgo/constants';
import '../../utils/normalizr/constants.js';
import 'query-string';
import '../../utils/normalizr/utils.js';

function live(backendAxiosInstance) {
  async function getChannels(assetToken) {
    const response = await backendAxiosInstance.get("/contents/v2/live/channels", {
      params: {
        assetToken
      }
    });
    response.normalizedData = normalize(response.data.channels, [ChannelEntity]);
    return response;
  }
  async function getSchedules({
    startTime,
    endTime,
    channelId: channelIds,
    assetToken,
    ...restParams
  }) {
    const response = await backendAxiosInstance.get("/contents/v2/live/schedules", {
      params: {
        startTime: startTime.toISOString(),
        endTime: endTime?.toISOString(),
        channelId: channelIds.join(","),
        assetToken,
        ...restParams
      },
      includeLanguage: true
    });
    response.normalizedData = normalize(
      // Drop other atributes to avoid rerenders and issues
      response.data.channels.map(({ channelId, schedules }) => ({ channelId, schedules })),
      [ChannelEntity]
    );
    return response;
  }
  async function getSchedulesByEventType(channel, {
    assetToken,
    eventType,
    pageSize
  }) {
    const response = await backendAxiosInstance.get(`/contents/v2/live/schedules/channel/${channel}`, {
      params: {
        eventType,
        pageSize,
        assetToken
      },
      includeLanguage: true
    });
    response.normalizedData = normalize(
      // Drop other atributes to avoid rerenders and issues
      response.data.channels.map(({ channelId, schedules }) => ({ channelId, schedules })),
      [ChannelEntity]
    );
    return response;
  }
  return {
    getChannels,
    getSchedules,
    getSchedulesByEventType
  };
}

export { live as default };
//# sourceMappingURL=live.js.map
